const defaultAvatar = new URL("../../assets/default-avatar.png", import.meta.url).href;

export default defaultAvatar;
